import { SearchOutlined } from "@ant-design/icons";
import { Input, Select } from "antd";
import {
	FINDING_STATUS_FILTER_OPTIONS,
	FindingFilters,
} from "../../../utils/reporting/findingFilters";
import { ReportItemKind } from "../../../utils/reporting/reportItemKinds";

type Option = { label: string; value: string };

type ReportItemsFilterBarProps = {
	// Names the items in the search box and the type filter.
	kind: ReportItemKind;
	filters: FindingFilters;
	onChange: (filters: FindingFilters) => void;
	showStatusFilter: boolean;
	responsibleOptions: Option[];
	typeOptions: Option[];
};

const ReportItemsFilterBar = ({
	kind,
	filters,
	onChange,
	showStatusFilter,
	responsibleOptions,
	typeOptions,
}: ReportItemsFilterBarProps) => {
	const multiSelectProps = {
		mode: "multiple" as const,
		allowClear: true,
		maxTagCount: "responsive" as const,
		optionFilterProp: "label",
		popupMatchSelectWidth: false,
		className: "w-44",
	};
	const searchLabel = `Search ${kind.plural}`;

	return (
		<div className="report-items-filter-bar flex flex-wrap items-center gap-2">
			<Input
				className="min-w-50 flex-1"
				placeholder={searchLabel}
				aria-label={searchLabel}
				prefix={<SearchOutlined />}
				allowClear
				value={filters.search}
				onChange={(e) => onChange({ ...filters, search: e.target.value })}
			/>
			{showStatusFilter && (
				<Select
					{...multiSelectProps}
					placeholder="Status"
					aria-label="Filter by status"
					options={FINDING_STATUS_FILTER_OPTIONS}
					value={filters.statuses}
					onChange={(statuses) => onChange({ ...filters, statuses })}
				/>
			)}
			{responsibleOptions.length > 0 && (
				<Select
					{...multiSelectProps}
					placeholder="Responsible"
					aria-label="Filter by responsible"
					options={responsibleOptions}
					value={filters.responsible}
					onChange={(responsible) => onChange({ ...filters, responsible })}
				/>
			)}
			{typeOptions.length > 0 && (
				<Select
					{...multiSelectProps}
					placeholder="Type"
					aria-label={`Filter by ${kind.noun} type`}
					options={typeOptions}
					value={filters.types}
					onChange={(types) => onChange({ ...filters, types })}
				/>
			)}
		</div>
	);
};

export default ReportItemsFilterBar;
